import React from "react";

import { MainLayoutContent } from "../../../layouts/MainLayout/MainLayoutContent";
import { useTranslation } from "react-i18next";
// import { Row } from "../../../components/Listing/TypedDatatable";
import ListReviews from "../../../components/review/ListReviews/ListReviews";
import { MdReviews } from "react-icons/md";
// import { Review } from "../../../services/review/review.srv";

const ReviewsListPage = () => {
  const { t } = useTranslation();

  // STATES
  // const [refresh, setRefresh] = useState<string>("");
  // const [reviewModelAction, setReviewModelAction] = useState<
  //   { type: "ADD" } | { type: "EDIT"; review: Review | Row<Review> } | null
  // >(null);

  return (
    <div>
      <MainLayoutContent
        navigations={[
          {
            label: t("model.review.plural"),
            link: "/",
            icon: <MdReviews />,
            isMain: true,
          },
        ]}
      >
        <ListReviews
          refresh={"refresh"}
          handleRecordClick={() => {
            // console.log("handleRecordClick", item);
            // setReviewModelAction({ type: "EDIT", review: item });
          }}
        />

        {/* {tagModelAction && (
          <ManageMenuItemTagModel
            open={true}
            action={tagModelAction}
            onOk={() => {
              setRefresh(Math.random().toString());
              setTagModelAction(null);
            }}
            onCancel={() => {
              setTagModelAction(null);
            }}
          />
        )} */}
      </MainLayoutContent>
    </div>
  );
};

export default ReviewsListPage;
